<template>
    <div class="supplier-info">
        <div class="supplier-table">
            <el-table :data="supplierData" border>
                <el-table-column label="序号" type="index" width="80"></el-table-column>
                <el-table-column label="供应商名称" prop="name"></el-table-column>
                <el-table-column label="供应商编号" prop="code"></el-table-column>
                <el-table-column label="单价" prop="price"></el-table-column>
                <el-table-column label="交期" prop="deliveryTime"></el-table-column>
                <el-table-column label="采购链接" prop="purchaseLink"></el-table-column>
                <el-table-column label="首选" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="preferredSupplier" :label="scope.row.id"></el-radio>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleDelete(scope.row)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-button type="text" icon="el-icon-plus" @click="handleAdd">添加</el-button>
        </div>

        <div class="purchase-history">
            <div class="section-title">采购记录</div>
            <el-table :data="purchaseHistory" border>
                <el-table-column label="采购单号" prop="orderNo"></el-table-column>
                <el-table-column label="创建时间" prop="createTime"></el-table-column>
                <el-table-column label="采购数量" prop="quantity"></el-table-column>
                <el-table-column label="采购单价" prop="price"></el-table-column>
                <el-table-column label="合计" prop="total"></el-table-column>
                <el-table-column label="到货数量" prop="receivedQuantity"></el-table-column>
                <el-table-column label="供应商" prop="supplier"></el-table-column>
                <el-table-column label="仓库" prop="warehouse"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SupplierInfo',
    data() {
        return {
            supplierData: [],
            purchaseHistory: [],
            preferredSupplier: ''
        }
    },
    methods: {
        handleDelete(row) {
            // 处理删除逻辑
        },
        handleAdd() {
            // 处理添加逻辑
        }
    }
}
</script>